import React from 'react';

const UptimeHealth = ({ isActive }) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 12H9L12 5L14 18.5L17.5 12H21.5'
        stroke={isActive ? '#ffffffa3' :'#525876'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default UptimeHealth;
